import DailyTop3RankReward, * as DailyTop3RankRewardModule from './daily-top3-rank-reward'
import Dialog, * as DialogModule from './dialog'
import Diamond, * as DiamondModule from './diamond'
import EggConfig, * as EggConfigModule from './egg-config'
import Header, * as HeaderModule from './header'
import Image, * as ImageModule from './image'
import InputNumber, * as InputNumberModule from './input-number'
import LotteryRecord, * as LotteryRecordModule from './lottery-record'
import Modal, * as ModalModule from './modal'
import Rank, * as RankModule from './rank'
import RankTabs, * as RankTabsModule from './rank-tabs'
import RewardItem, * as RewardItemModule from './reward-item'
import RewardSwiper, * as RewardSwiperModule from './reward-swiper'
import RichTextRender, * as RichTextRenderModule from './rich-text-render'
import SudokuTurntable, * as SudokuTurntableModule from './sudoku-turntable'
import Tab, * as TabModule from './tab'
import Table, * as TableModule from './table'
import Tabs, * as TabsModule from './tabs'
import TopBar, * as TopBarModule from './top-bar'
import TopThree, * as TopThreeModule from './top-three'
import Turntable, * as TurntableModule from './turntable'
import Waterfall, * as WaterfallModule from './waterfall'

export const _DailyTop3RankRewardComponent = DailyTop3RankRewardModule._DailyTop3RankRewardComponent || {}
export const _DialogComponent = DialogModule._DialogComponent || {}
export const _DiamondComponent = DiamondModule._DiamondComponent || {}
export const _EggConfigComponent = EggConfigModule._EggConfigComponent || {}
export const _HeaderComponent = HeaderModule._HeaderComponent || {}
export const _ImageComponent = ImageModule._ImageComponent || {}
export const _InputNumberComponent = InputNumberModule._InputNumberComponent || {}
export const _LotteryRecordComponent = LotteryRecordModule._LotteryRecordComponent || {}
export const _ModalComponent = ModalModule._ModalComponent || {}
export const _RankComponent = RankModule._RankComponent || {}
export const _RankTabsComponent = RankTabsModule._RankTabsComponent || {}
export const _RewardItemComponent = RewardItemModule._RewardItemComponent || {}
export const _RewardSwiperComponent = RewardSwiperModule._RewardSwiperComponent || {}
export const _RichTextRenderComponent = RichTextRenderModule._RichTextRenderComponent || {}
export const _SudokuTurntableComponent = SudokuTurntableModule._SudokuTurntableComponent || {}
export const _TabComponent = TabModule._TabComponent || {}
export const _TableComponent = TableModule._TableComponent || {}
export const _TabsComponent = TabsModule._TabsComponent || {}
export const _TopBarComponent = TopBarModule._TopBarComponent || {}
export const _TopThreeComponent = TopThreeModule._TopThreeComponent || {}
export const _TurntableComponent = TurntableModule._TurntableComponent || {}
export const _WaterfallComponent = WaterfallModule._WaterfallComponent || {}


function install(app) {
  DailyTop3RankReward.install && app.use(DailyTop3RankReward)
  Dialog.install && app.use(Dialog)
  Diamond.install && app.use(Diamond)
  EggConfig.install && app.use(EggConfig)
  Header.install && app.use(Header)
  Image.install && app.use(Image)
  InputNumber.install && app.use(InputNumber)
  LotteryRecord.install && app.use(LotteryRecord)
  Modal.install && app.use(Modal)
  Rank.install && app.use(Rank)
  RankTabs.install && app.use(RankTabs)
  RewardItem.install && app.use(RewardItem)
  RewardSwiper.install && app.use(RewardSwiper)
  RichTextRender.install && app.use(RichTextRender)
  SudokuTurntable.install && app.use(SudokuTurntable)
  Tab.install && app.use(Tab)
  Table.install && app.use(Table)
  Tabs.install && app.use(Tabs)
  TopBar.install && app.use(TopBar)
  TopThree.install && app.use(TopThree)
  Turntable.install && app.use(Turntable)
  Waterfall.install && app.use(Waterfall)
}

export {
  install,
  DailyTop3RankReward,
  Dialog,
  Diamond,
  EggConfig,
  Header,
  Image,
  InputNumber,
  LotteryRecord,
  Modal,
  Rank,
  RankTabs,
  RewardItem,
  RewardSwiper,
  RichTextRender,
  SudokuTurntable,
  Tab,
  Table,
  Tabs,
  TopBar,
  TopThree,
  Turntable,
  Waterfall
}

export default {
  install,
  DailyTop3RankReward,
  Dialog,
  Diamond,
  EggConfig,
  Header,
  Image,
  InputNumber,
  LotteryRecord,
  Modal,
  Rank,
  RankTabs,
  RewardItem,
  RewardSwiper,
  RichTextRender,
  SudokuTurntable,
  Tab,
  Table,
  Tabs,
  TopBar,
  TopThree,
  Turntable,
  Waterfall
}
